import React, { useEffect, useState } from "react";
import "../../css/CustomDropdown.css"; // Import CSS

const CustomDropdown = ({
  formData,
  handleInputChange,
  index,
  i = null,
  field,
  options = [],
  placeholder = "Select...",
  required = false,
  onSelect = () => {},
  multiple = false,
}) => {
  const [selected, setSelected] = useState(multiple ? [] : placeholder);
  const [showDropdown, setShowDropdown] = useState(false);

  // Handle selection of an option from the dropdown
  const handleSelect = (option) => {
    if (multiple) {
      let updated = Array.isArray(selected) ? [...selected] : [];
      const isSelected = updated.includes(option.value);

      updated = isSelected
        ? updated.filter((val) => val !== option.value)
        : [...updated, option.value];

      setSelected(updated);
      handleInputChange(index, field, updated, i);
      onSelect(updated);
    } else {
      setSelected(option.label);
      setShowDropdown(false);
      handleInputChange(index, field, option.value, i);
      onSelect(option);
    }
  };

  // Sync component state with incoming formData on mount or when dependencies change
  useEffect(() => {
    const data =
      i !== null ? formData?.[index]?.[i]?.[field] : formData?.[index]?.[field];

    if (multiple) {
      setSelected(Array.isArray(data) ? data : []);
    } else {
      const matched = options.find((option) => option.value === data);
      setSelected(matched ? matched.label : placeholder);
    }
  }, [formData, index, i, field, options, placeholder, multiple]);

  return (
    <div
      className="custom-select-container"
      data-index={index}
      data-field={field}
    >
      {/* Display selected values */}
      <div
        className={`custom-select ${showDropdown ? "active" : ""}`}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        {multiple
          ? selected.length > 0
            ? selected
                .map(
                  (val) => options.find((option) => option.value === val)?.label
                )
                .join(", ")
            : placeholder
          : selected}
        {required === "1" && <span className="required_dropdown_field">*</span>}
      </div>

      {/* Options List */}
      <ul className={`custom-dropdown ${showDropdown ? "active" : ""}`}>
        {options.map((option, idx) => {
          const isActive = multiple
            ? Array.isArray(selected) && selected.includes(option.value)
            : selected === option.label;

          return (
            <li
              key={idx}
              onClick={() => handleSelect(option)}
              className={isActive ? "active" : ""}
            >
              {option.label}
              {multiple && isActive && (
                <span className="selected-checkmark"> ✔</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CustomDropdown;
